import React from 'react';

import { useFormContext } from 'react-hook-form';
import { Button } from '@mui/material';

import { LbSelect } from '@infoods/lifebase-ui';
import { ModalInputBox, ModalInputGroup } from '../../../../../../../components/modals';
import { CustomFilterFormValues } from '../../AddCustomFilterForm.settings';

import { HiddenInput } from '../../../../../../../components/form-components';
import { h20bScaleStatusOptions } from '../../../../../../../constants/inbody-info/h20bInfo';
import { useClearFilter } from '../../hooks/useClearFilter';

const H20BStatus = () => {
  const { control, register } = useFormContext<CustomFilterFormValues>();

  const { disabled, handleClearFields } = useClearFilter('H20B_STATUS', {
    status: '',
  });

  return (
    <ModalInputBox
      title="H20B Status"
      adornment={
        <Button
          size="small"
          variant="text"
          color="secondary"
          onClick={handleClearFields}
          disabled={disabled}
        >
          Clear
        </Button>
      }
    >
      <HiddenInput
        register={register}
        name="filters.H20B_STATUS.filterType"
        value="H20B_STATUS"
      />
      <ModalInputGroup>
        <LbSelect
          control={control}
          size="small"
          variant="outlined"
          name="filters.H20B_STATUS.status"
          label="Select InBody Status"
          options={h20bScaleStatusOptions}
        />
      </ModalInputGroup>
    </ModalInputBox>
  );
};

export { H20BStatus };
